import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function ColegiosSidebar() {
  return <ModuleSidebar config={MODULES.colegios} />;
}
